import {api} from "./api";

export const giftBillsWaitingApi = {
    getBills : (data) => api.post("/api/get-giftbills" ,data),
    acceptBill : (id) => api.get(`/api/accept-bill/${id}`) ,
    rejectBill : (id) => api.get(`/api/reject-bill/${id}`)
}